import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "components/common/Tooltip";

/// `label` names the hint for assistive tech.
export const InfoHint: React.FC<{ title: React.ReactNode; label: string }> = ({
  title,
  label,
}) => (
  <Tooltip title={title}>
    <InfoOutlinedIcon
      sx={{ fontSize: 14 }}
      className="text-fg-muted-medium cursor-help"
      aria-label={label}
    />
  </Tooltip>
);
